import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';

/**
 * Valor do widget `richtext` (HtmlSlateWidget): objeto com o HTML em `data`.
 * Aceita string crua também, porque conteúdo semeado via API chega assim.
 */
export type RichTextFieldValue =
  | string
  | {
      data?: string;
      'content-type'?: string;
      encoding?: string;
    };

export type InstitutionalBlurbItem = {
  '@id'?: string;
  heading?: string;
  text?: RichTextFieldValue;
};

export type InstitutionalBlurbData = {
  items?: InstitutionalBlurbItem[];
};

type InstitutionalBlurbBodyProps = {
  data: InstitutionalBlurbData;
  isEditMode?: boolean;
};

const getHtml = (text?: RichTextFieldValue): string => {
  if (!text) return '';
  return typeof text === 'string' ? text : text.data || '';
};

/**
 * Sanitiza antes de injetar: o HTML vem do editor (confiável) mas pode ter sido
 * semeado pela API, então não é seguro por construção. Mesmo tratamento das
 * respostas do FAQ.
 */
const renderText = (text?: RichTextFieldValue) => {
  const html = getHtml(text);
  if (!html) return null;
  return parse(DOMPurify.sanitize(html));
};

const InstitutionalBlurbBody = ({
  data,
  isEditMode,
}: InstitutionalBlurbBodyProps) => {
  const items = data.items || [];

  // Na página, um bloco sem parceiros não deixa faixa vazia. No editor ele
  // precisa continuar existindo, senão vira um bloco invisível e impossível de
  // selecionar para configurar (block-architecture.md §1).
  if (items.length === 0 && !isEditMode) {
    return null;
  }

  return (
    <aside className="block-institutional-blurb">
      <div className="institutional-blurb__inner">
        {items.map((item, index) => (
          <section
            className="institutional-blurb__item"
            key={item['@id'] ?? index}
          >
            {item.heading ? <h2>{item.heading}</h2> : null}
            {renderText(item.text)}
          </section>
        ))}
      </div>
    </aside>
  );
};

export default InstitutionalBlurbBody;
